import { debounce } from "../utils.js";

gsap.registerPlugin(ScrollTrigger);


export function initStickyElements() {
	try {
		/**
		 * Social sticky
		 */





	} catch (error) {
		console.error(
			"Sticky elements error:",
			error
		);
	}
}
initStickyElements();


function updateStickyNavActive() {
	const $stickyNav = $(".sticky-nav");
	const $header = $("header");
	const $sections = $(".scroll-section-wrap .anchor-section-id");

	if (!$stickyNav.length || !$sections.length) return;

	const scrollDistance = $(window).scrollTop();
	const offset = $stickyNav.outerHeight() + $header.outerHeight() + 1;
	let activeIndex = 0;

	$sections.each(function (i) {
		if ($(this).offset().top - offset <= scrollDistance) {
			activeIndex = i;
		}
	});

	$stickyNav.find("li.is-active").removeClass("is-active");
	$stickyNav.find("li").eq(activeIndex).addClass("is-active");
}


export function initHomeServiceScroll() {
	gsap.registerPlugin(ScrollTrigger);

	const items = document.querySelectorAll(".home-service .item");

	if (!items.length) {
		return;
	}

	/**
	 * Use gsap.matchMedia so all ScrollTriggers are scoped to desktop
	 * and automatically killed / reverted on mobile.
	 */
	const mm = gsap.matchMedia();

	mm.add("(min-width: 1024.1px)", () => {
		items.forEach((item, index) => {
			const revealElement = item.querySelector(".img");
			const revealContent = item.querySelector(".txt");

			/**
			 * Initial state — scale from the top so the item's head
			 * is never clipped when it enters scaled-up.
			 */
			gsap.set(item, {
				scale: 1.111,
				transformOrigin: "top center"
			});

			if (revealContent) {
				gsap.set(revealContent, {
					y: 80,
					opacity: 0
				});
			}

			/**
			 * Sticky stack — fires only after the item is FULLY visible
			 * in the viewport + a 40 px breathing gap.
			 * "bottom bottom-=80" = item's bottom edge is 40 px above
			 * the viewport bottom → item is 100% in view + 40 px.
			 *
			 * pinnedContainer top offset: each pinned card sits 40px
			 * below the previous one (index * 40px from top).
			 */
			ScrollTrigger.create({
				trigger: item,
				start: "bottom bottom-=80",
				end: "bottom top",
				pin: true,
				pinSpacing: false,
				scrub: true,
				pinnedContainer: item.parentElement,
				invalidateOnRefresh: true
			});

			/**
			 * Scale down while scrolling in.
			 * End matches the pin start so the card is fully scaled
			 * before it locks into place.
			 */
			gsap.to(item, {
				scale: 1,
				ease: "none",
				scrollTrigger: {
					trigger: item,
					start: "top bottom",
					end: "bottom bottom-=80",
					scrub: 1.2,
					invalidateOnRefresh: true
				}
			});

			/**
			 * Image subtle zoom out
			 */
			if (revealElement) {
				gsap.fromTo(
					revealElement,
					{ scale: 1.1 },
					{
						scale: 1,
						ease: "none",
						scrollTrigger: {
							trigger: item,
							start: "top 80%",
							end: "bottom bottom-=80",
							scrub: 1.2,
							invalidateOnRefresh: true
						}
					}
				);
			}

			/**
			 * Text reveal
			 */
			if (revealContent) {
				gsap.to(revealContent, {
					y: 0,
					opacity: 1,
					ease: "power2.out",
					scrollTrigger: {
						trigger: item,
						start: "top 85%",
						end: "top 40%",
						scrub: 1.2,
						invalidateOnRefresh: true
					}
				});
			}
		});

		ScrollTrigger.refresh();

		/**
		 * Re-calculate pin positions on resize so the 40 px gap
		 * stays accurate after viewport changes.
		 */
		const onResize = debounce(() => ScrollTrigger.refresh(), 300);
		window.addEventListener("resize", onResize);

		// Cleanup returned to matchMedia context on breakpoint exit
		return () => {
			window.removeEventListener("resize", onResize);
		};
	});
}



import { CONFIG, throttle } from "../utils";

export function initScroll() {

	const onScroll = () => {
		const scrollTop = window.scrollY;



		// Back-to-top visibility
		const backTop = document.querySelector(".back-to-top");

		if (backTop) {
			backTop.classList.toggle("show", scrollTop > 300);
		}
		updateStickyNavActive();
	};

	window.addEventListener("scroll", throttle(onScroll, 100));



}

export function handleScroll() {
	const scrollTop = window.scrollY;


	// Back-to-top visibility
	const backTop = document.querySelector(".back-to-top");

	if (backTop) {
		backTop.classList.toggle("show", scrollTop > 300);

		backTop.addEventListener("click", (e) => {
			e.preventDefault();

			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		});
	}

}
